export const contacts = {
  phone: {
    main: {
      hyphens: "855-272-8670",
      parens: "(855) 272-8670",
    },
  },
  social: {
    facebook: "https://www.facebook.com/HOLTUsed",
    instagram: "https://www.instagram.com/holtused",
    linkedIn: "https://www.linkedin.com/company/holt-used",
    twitter: "https://twitter.com/HoltUsed",
  },
};
